import { render, staticRenderFns } from "./AboutE.vue?vue&type=template&id=386a5329&scoped=true&"
import script from "./AboutE.vue?vue&type=script&lang=js&"
export * from "./AboutE.vue?vue&type=script&lang=js&"
import style0 from "./AboutE.vue?vue&type=style&index=0&id=386a5329&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a5329",
  null
  
)

export default component.exports